import {TRANSLATION, Yup} from '@/imports-files/pages/admins/otp';

export const OTP_LENGTH = 6;

export const INITIAL_VALUES = {otp: ''};

export const VALIDATION_SCHEMA = Yup.object({otp: Yup.string()
    .required(TRANSLATION('common:errors:required'))
    .max(OTP_LENGTH)});
